export default __webpack_public_path__ + "static/media/logo3.cd1cffb7.png";